// Theme-aware colors using CSS variables
export const colors = {
  transparent: 'transparent',
  // Brand colors
  primary: 'var(--color-primary)',
  primaryActive: 'var(--color-primary-active)',
  primaryClarity: 'var(--color-primary-clarity)',
  primaryLight: 'var(--color-primary-light)',

  secondary: 'var(--color-secondary)',
  secondaryActive: 'var(--color-secondary-active)',
  secondaryClarity: 'var(--color-secondary-clarity)',
  secondaryLight: 'var(--color-secondary-light)',

  success: 'var(--color-success)',
  successActive: 'var(--color-success-active)',
  successClarity: 'var(--color-success-clarity)',
  successLight: 'var(--color-success-light)',

  danger: 'var(--color-danger)',
  dangerActive: 'var(--color-danger-active)',
  dangerClarity: 'var(--color-danger-clarity)',
  dangerLight: 'var(--color-danger-light)',

  warning: 'var(--color-warning)',
  warningActive: 'var(--color-warning-active)',
  warningClarity: 'var(--color-warning-clarity)',
  warningLight: 'var(--color-warning-light)',

  info: 'var(--color-info)',
  infoActive: 'var(--color-info-active)',
  infoClarity: 'var(--color-info-clarity)',
  infoLight: 'var(--color-info-light)',

  white: 'var(--color-white)',
  lightActive: 'var(--color-light-active)',
  lightClarity: 'var(--color-light-clarity)',

  // Grey scale
  grey100: 'var(--color-grey-100)',
  grey200: 'var(--color-grey-200)',
  grey300: 'var(--color-grey-300)',
  grey400: 'var(--color-grey-400)',
  grey500: 'var(--color-grey-500)',
  grey600: 'var(--color-grey-600)',
  grey700: 'var(--color-grey-700)',
  grey800: 'var(--color-grey-800)',
  grey900: 'var(--color-grey-900)',

  // Gradient colors for progress bars
  gradient1: 'var(--color-gradient-1)',
  gradient2: 'var(--color-gradient-2)',
  gradient3: 'var(--color-gradient-3)',

  textPrimary: 'var(--color-text-primary)',
  textSecondary: 'var(--color-text-secondary)',
  textMuted: 'var(--color-text-muted)',
  textDisabled: 'var(--color-text-disabled)',

  // Background colors
  bgPrimary: 'var(--color-bg-primary)',
  bgSecondary: 'var(--color-bg-secondary)',
  bgTertiary: 'var(--color-bg-tertiary)',
  bgDisabled: 'var(--color-bg-disabled)',

  // Border colors
  borderPrimary: 'var(--color-border-primary)',
  borderSecondary: 'var(--color-border-secondary)',
  borderFocus: 'var(--color-border-focus)',

  // Surface colors
  surfacePrimary: 'var(--color-surface-primary)',
  surfaceSecondary: 'var(--color-surface-secondary)',
  surfaceElevated: 'var(--color-surface-elevated)',

  // Input colors
  inputBg: 'var(--color-input-bg)',
  inputBorder: 'var(--color-input-border)',
  inputBorderFocus: 'var(--color-input-border-focus)',
  inputText: 'var(--color-input-text)',
  inputPlaceholder: 'var(--color-input-placeholder)',

  // Button colors
  buttonPrimaryBg: 'var(--color-button-primary-bg)',
  buttonPrimaryText: 'var(--color-button-primary-text)',
  buttonPrimaryHover: 'var(--color-button-primary-hover)',

  // Switch colors
  switchTrackActive: 'var(--color-switch-track-active)',
  switchTrackInactive: 'var(--color-switch-track-inactive)',
  switchThumb: 'var(--color-switch-thumb)',

  // Slider colors
  sliderTrack: 'var(--color-slider-track)',
  sliderProgress: 'var(--color-slider-progress)',
  sliderThumb: 'var(--color-slider-thumb)',
  sliderThumbBorder: 'var(--color-slider-thumb-border)',

  // Additional semantic colors
  borderHover: 'var(--color-border-hover)',

  shadowLight: 'rgba(0, 0, 0, 0.1)',
  shadowMedium: 'rgba(0, 0, 0, 0.2)',
  shadowDark: 'rgba(0, 0, 0, 0.5)',

  // Overlay colors for gradients
  overlayTransparent: 'rgba(0, 0, 0, 0)',
  overlayDark: 'rgba(0, 0, 0, 0.6)',
} as const

export type ColorValue = (typeof colors)[keyof typeof colors]
